<template>
    <header class="app-header navbar">
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            &#9776;
        </button>
        <b-link class="navbar-brand" to="/"></b-link>

        <header-breadcrumbs :list="breadcrumbs"/>

        <b-nav is-nav-bar class="ml-auto">
            <div class="navbar-text mr-3">
                <span class="badge badge-info font-weight-normal">Банковский курс SPD: <span class="font-weight-bold">{{ rate }}</span> <small>EUR</small></span>
            </div>

            <b-nav-item class="d-md-down-none" hidden>
                <i class="icon-bell"></i><span class="badge badge-pill badge-danger" v-if="notificationsCount">{{ notificationsCount }}</span>
            </b-nav-item>
            <span class="navbar-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="navbar-text">{{ fullname }} &nbsp;&nbsp;&nbsp;</span>
            <img :src="avatar" class="img-avatar" :alt="username">
        </b-nav>
        <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle" style="display: none;">
            <img src="../assets/img/profi_planet_logo.png" alt="Profi-Planet" class="logo">
        </button>
    </header>
</template>
<script>
    import Breadcrumb from './Breadcrumb.vue'

    export default {
        name: 'header',
        components: {
            'header-breadcrumbs': Breadcrumb
        },
        data () {
            return {}
        },
        computed: {
            breadcrumbs () {
                return this.$route.matched
            },
            avatar () {
                return 'static/img/avatar.png'
            },
            rate () {
                return this.$store.state.finance['rate'].toFixed(4)
            },
            notifications () {
                return this.$store.state.user['notifications']
            },
            notificationsCount () {
                return this.notifications.length
            },
            username () {
                return this.$store.state.user['userdata']['username']
            },
            fullname () {
                return this.$store.state.user['userdata']['lastname'] + ' ' + this.$store.state.user['userdata']['firstname']
            }
        },
        mounted () {},
        methods: {
            sidebarToggle (e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-hidden')
            },
            /* sidebarMinimize (e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-minimized')
            }, */
            mobileSidebarToggle (e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-mobile-show')
            },
            asideToggle (e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
            logout () {
                this.$auth.logout({
                    redirect: '/'
                })
            }
        }
    }
</script>

<style>
    button > img.logo {
        width: 36px;
    }
    .img-avatar {
        height: 48px;
        margin-right: 8px;
    }
</style>


// WEBPACK FOOTER //
// Header.vue?49e6cccc